import React, { useContext, useEffect, useState } from 'react'
import plus from '../dist/webImages/plus.svg'
import { Link } from 'react-router-dom';
import useGet from '../customHooks/useGet';
import { MainLanguageContext } from '../context/MainLanguageContext';
import usePost from '../customHooks/usePost';
import { Pagination } from 'antd';
import SkeletonCreateEdit from './SkeletonCreateEdit';
import NewsCard from './NewsCard';

const News = ({ permission }) => {
  const { mainLanguage } = useContext(MainLanguageContext);
  const [datas, setDatas] = useState();
  const [resget, apiMethodGet] = useGet();
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationn, setPaginationn] = useState(6);
  const [searchValue, setSearchValue] = useState("");
  const [res2, apiMethod2] = usePost();

  const onChange = (current) => {
    setCurrentPage(current);
    const formdata = new FormData();
    formdata.append('search_query', searchValue);
    if (searchValue.trim()) {
      apiMethod2(`news/search_news_list/${mainLanguage}/6?page=${current}`, formdata);
    } else {
      apiMethodGet(`news/list/${mainLanguage}/6?page=${current}`);
    }
  };

  useEffect(() => {
    if (mainLanguage) {
      setCurrentPage(1);
      apiMethodGet(`news/list/${mainLanguage}/6?page=1`);
    }
  }, [mainLanguage]);

  let debounceTimer;
  const debounce = (func, delay) => (...args) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func(...args), delay);
  };

  const executeApiCall = (e) => {
    setSearchValue(e.target.value);
    const formdata = new FormData();
    formdata.append('search_query', e.target.value);
    if (e.target.value.trim()) {
      apiMethod2(`news/search_news_list/${mainLanguage}/6?page=${currentPage}`, formdata);
    } else {
      apiMethodGet(`news/list/${mainLanguage}/6?page=${currentPage}`);
    }
  };
  const handleChange = debounce(executeApiCall, 1000);

  useEffect(() => {
    if (!resget.isLoading) {
      setDatas(resget?.data?.data);
      setPaginationn(resget.data?.pagination);
    }
  }, [resget.data]);

  useEffect(() => {
    setDatas([]);
    if (res2.data) {
      setDatas(res2?.data?.data);
      setPaginationn(res2?.data?.pagination);
    }
  }, [res2.data]);

  const check = (module, action) => permission?.[module]?.includes(action);
  return (
    <div className='NewsPage pr-10 max-lg:pr-6'>
      <div className="TeamPageTop flex justify-between items-center">
        <h6 className='text-[1rem] mb-2 bookingSectionh relative px-3 font-Mluvka capitalize'>News and updates</h6>
        <div className='flex gap-1'>
          <div className="inputBox w-[16rem] max-lg:hidden">
            <input type="text" onChange={handleChange} className='w-full border h-[2.8rem] rounded-full px-4 border-[#ddd] outline-none' placeholder='Search' />
          </div>
          {check("News", "News Add") && <Link to={"/news/create"} className='bg-[#d9dcf8] py-3 px-6 rounded-full flex items-center gap-2 cursor-pointer'>
            <img src={plus} alt="plus" style={{ filter: "brightness(100)" }} />
            <span className='font-MluvkaBold text-white capitalize'>Add news</span>
          </Link>}
        </div>
      </div>
      <div className="NewsPageGrid mt-4 bg-[#EFF4FD] rounded-3xl p-6 grid grid-cols-1 gap-3 max-lg:p-3">
        {resget.isLoading ? Array.from({ length: 6 }).map((_, index) => <SkeletonCreateEdit key={index} />) : Array.isArray(datas) && datas.map((item, index) => <NewsCard key={index} data={item} />)}
      </div>
      <div className='mt-4'>
        <Pagination
          onChange={onChange}
          defaultCurrent={currentPage}
          total={paginationn?.total}
          pageSize={6}
          showSizeChanger={false}
        />
      </div>
    </div>
  )
}

export default News
